<template>
  <div>
    <Preloader v-if="localLoading" />
    <template v-else>
      <OrderPlan v-if="type === 'plan'" :id="parseInt(id)" :renew="renew" />
      <OrderQuota :type="type" :item-type="id.toString()" v-if="type === 'quota'" />
    </template>
  </div>
</template>

<script>
import OrderPlan from '@/components/Payment/Order/Plan/OrderPlan';
import useAccount from '@/compositions/accounting/useAccount';
import useValidation from '@/compositions/useValidation';
import Preloader from '@/components/Preloader';
import OrderQuota from '@/components/Payment/Order/Plan/OrderQuota';

export default {
  name: 'Order',
  components: { OrderQuota, Preloader, OrderPlan },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    renew: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { withLoading, localLoading } = useValidation();
    const { fetch } = useAccount();

    withLoading(async () => {
      await fetch();
    });

    return {
      withLoading,
      localLoading,
    };
  },
};
</script>

<style scoped>

</style>
